
<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">
      <button class="top_button" (click)="addTeam()">
        Add<em class="ti-plus"></em> 
      </button>

      <div class="right_part">

      </div>
    </div>
    <div class="custom_table_three_row" >
      <form [formGroup]="teamForm">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Team Name</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" formArrayName="Teams">
          <div
            class="td"
            *ngFor="
              let team of teamForm.get(
                'Teams'
              )['controls'];
              index as i
            "
            [formGroupName]="i"
          >
            <span class="head">{{ i + 1 }}</span>
            <span
              ><input
                type="text"
                formControlName="CorrespondenceTeamName"
                placeholder="Enter Team Name"
            /></span>
            <span
              ><button
                class="delete_icon trash"
                (click)="deleteTeam(i, team.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>
        </div>

        <div class="submit">
          <button
            class="submit_button"
            (click)="onSubmit(teamForm.value)"
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
